// const API_BASE_URL = "http://localhost:5000";
const API_BASE_URL = process.env.REACT_APP_TIGERSHEET_ASSISANT_API_BASE_URL;
console.log(`API_BASE_URL->`, API_BASE_URL);
console.log(`enableErrorNotification->`, process.env.REACT_APP_ENABLE_TIGERSHEET_ASSISANT_ERROR_NOTIFICATION == "1");

const assistantConfig = {
  chatConfig: {
    // include: ["system-messages", "initial-messages", "functions"],
    headers: {
      "Content-Type": "application/json",
    },
    body: {
      include: ["system-messages", "initial-messages", "functions"],
      frequency_penalty: 0,
      max_tokens: 2048,
      model: "gpt-4", // Will override chat settings model if provided
      // model: "gpt-4-1106-preview",
      // model:'davinci:ft-riktam-2023-07-19-08-43-19',
      temperature: 0,
      top_p: 1,
      presence_penalty: 0,
      stream: true,
    },
  },
  useProxyServer: true,
  saveChats: true,
  // useApiKey: true,
  settings: {
    defaultOpenAIChatModelId: 8,
    defaultModelIdForFunctionCall: 8,
    useMatchingTokenModel: true,
    useAnotherModelForFunctionCall: true,
    enableErrorNotification:
      process.env.REACT_APP_ENABLE_TIGERSHEET_ASSISANT_ERROR_NOTIFICATION == "1",
  },
  apiEndpoints: {
    chatCompletion: "https://api.openai.com/v1/chat/completions",
    // getChatsConfig: "http://localhost:5000/chats/v1/config",
    // getChatsConfig: "http://18.139.227.188:5000/chats/v1/config",
    getChatsConfig: `${API_BASE_URL}/chats/v1/config`,

    // getChatsConfig: "https://testgpt.riktam.net/chats/v1/config",
    // chatsAccessToken: "/assistant/chats-token",

    // proxyChatCompletion: "/assistant/chat",
    // proxyChatCompletion: "http://localhost:5000/chats/v1/conversations",
    // proxyChatCompletion: "http://18.139.227.188:5000/chats/v1/conversations",
    // proxyChatCompletion: "http://tsassistantaitiger.tigersheet.com/chats/v1/conversations",
    // proxyChatCompletion: "https://testgpt.riktam.net/chats/v1/conversations",
    proxyChatCompletion: `${API_BASE_URL}/chats/v1/conversations`,
  },

  assistantApiBaseUrl: API_BASE_URL,

  about: {
    version: "0.1.0",
    stage: "beta",
    infoMessage: `The Tigersheet Assistant is now in beta! It's yours to explore. While we've done our best, there might be a bug or two hiding. If you find any, let us know! Your feedback is gold.`,
  },
};

export default assistantConfig;
